import { render, staticRenderFns } from "./myVideo.vue?vue&type=template&id=437f0073&scoped=true"
import script from "./myVideo.vue?vue&type=script&lang=js"
export * from "./myVideo.vue?vue&type=script&lang=js"
import style0 from "./myVideo.vue?vue&type=style&index=0&id=437f0073&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../youyidian_pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437f0073",
  null
  
)

export default component.exports